const instructionsDataInitial = [
    {
        id: 'prep',
        name: 'Prep asparagus, peas, shallots',
        steps: [
            { text: 'Snap off the bottoms/ends of the #asparagus#' },
            { text: 'Cut *asparagus* diagonally. For the length of the pieces: what length feels right for a bite of pasta? Maybe ¼ or ½ of an inch?' },
            { text: 'Remove the #peas# from their shells' },
            { text: 'Finely dice #shallots#' } 
        ]
    },
    {
        id: 'cream-sauce',
        name: 'Make cream sauce',
        steps: [
            { text: 'Coat pan with *olive oil*, put stove on medium-high heat, wait for oil to shimmer' },
            { text: 'Add *diced shallots* and a sprinkle of *salt*' },
            { 
                text: 'Cook *shallots* until soft and translucent (stirring frequently, about 10 minutes)',
                timer: 10 
            },
            { 
                text: 'Add #heavy cream#, lower heat, and simmer sauce to thicken (about 5 minutes)',
                timer: 5 
            },
            { text: 'Taste, and add more salt as needed (it brings out the shallot flavor)' },
            { text: 'Once sauce has thickened enough to coat the spoon, add *peas* and stir' }
        ]
    },
    {
        id: 'boil-asparagus',
        name: 'Boil asparagus',
        steps: [
            { text: 'Bring a pot of water to a boil, and add *salt*' },
            { text: 'Prepare a bowl of ice water' },
            { 
                text: 'Add *asparagus* to boiling water, and boil for 5 minutes (until soft)',
                timer: 5 
            },
            { text: 'Remove *asparagus* and place in ice water' } 
        ]
    },
    {
        id: 'saffron-tea',
        name: 'Make saffron tea',
        steps: [
            { text: 'Using a mortar & pestle (or <a href="https://www.archute.com/mortar-pestle-substitute/" target="_blank">a similar technique</a>) grind #saffron# with *salt* (flakey sea salt, if possible) to create a saffron-salt powder' },
            { text: 'Add a small amount of boiling water, and stir' }
        ]
    },
    {
        id: 'zest-parm-herbs',
        name: 'Prep lemon zest + parm, herbs',
        steps: [
            { text: 'Zest #lemon# and mix together with #parmesan#' },
            { text: 'Finely chop #parsley# and #tarragon#' },
        ]
    },
    {
        id: 'pasta',
        name: 'Cook pasta & combine',
        steps: [
            { text: 'Cook #pasta#' },
            { text: 'Once pasta is <i>almost</i>, ready add *saffron tea* to *cream sauce*. Stir to combine.' },
            { text: "Once pasta is ready, add pasta to cream sauce (don't need to drain, a little pasta water further thickens sauce)" },
            { text: 'Add *asparagus*, *lemon zest-parm* mixture' },
            { text: 'Top with *tarragon* and *parsley*' },
        ]
    }
]

function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/instructions', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));
  
const mediaBySection = allMedia.reduce((acc, path) => {
    const sectionId = path.split('_')[0].split('/').pop(); // Extract section id from path
    if (!acc[sectionId]) { acc[sectionId] = [] } // Initialize array if it doesn't exist
    acc[sectionId].push(path); // Add path to array
    return acc;
}, {});

export const instructions = instructionsDataInitial.map(section => {
    // if there's an array of media for the given section
    if (mediaBySection[section.id]) {
        // add media array
        return { ...section, media: mediaBySection[section.id] };
    } else {
        return section;
    }
})